// Valida CNPJ numérico (legado) e alfanumérico (IN RFB 2.229/2024).
// Algoritmo: Módulo 11 com conversão ASCII-48 (Serpro). Sem dependências externas.
function validateCNPJAlfanumero(cnpj) {
  const s = String(cnpj).replace(/[.\-\/]/g, '').toUpperCase();

  if (s.length !== 14) return false;
  if (/^(.)\1+$/.test(s)) return false;
  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(s)) return false;

  const v = Array.from(s.slice(0, 12), c => c.charCodeAt(0) - 48);

  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const r1 = v.reduce((sum, n, i) => sum + n * w1[i], 0) % 11;
  const dv1 = r1 < 2 ? 0 : 11 - r1;

  const w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const r2 = [...v, dv1].reduce((sum, n, i) => sum + n * w2[i], 0) % 11;
  const dv2 = r2 < 2 ? 0 : 11 - r2;

  return s[12] === String(dv1) && s[13] === String(dv2);
}

function validarCPF(cpf) {
  cpf = cpf.replace(/\./g, '');
  cpf = cpf.replace(/-/g, '');

  var i;
  var s = cpf;
  var c = s.substr(0, 9);
  var dv = s.substr(9, 2);
  var d1 = 0;

  if (cpf.length != 11 || cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
    return false;
  }

  for (i = 0; i < 9; i++) {
    d1 += c.charAt(i) * (10 - i);
  }

  if (d1 == 0) {
    return false;
  }

  d1 = 11 - (d1 % 11);
  if (d1 > 9) {
    d1 = 0;
  }

  if (dv.charAt(0) != d1) {
    return false;
  }

  d1 *= 2;
  for (i = 0; i < 9; i++) {
    d1 += c.charAt(i) * (11 - i);
  }

  d1 = 11 - (d1 % 11);
  if (d1 > 9) {
    d1 = 0;
  }

  if (dv.charAt(1) != d1) {
    return false;
  }

  return true;
};


export const cpf = {
  messages: {
    en: (field, args) => {
      return "CPF inválido.";
    },
    'pt-BR': (field, args) => {
      return "CPF inválido.";
    }
  },

  validate(value) {
    return validarCPF(value)
  }

};

export const cnpj = {
  messages: {
    en: (field, args) => {
      return "CNPJ inválido.";
    },
    'pt-BR': (field, args) => {
      return "CNPJ inválido.";
    }
  },

  validate(value) {
    return validateCNPJAlfanumero(value);
  }
};

export const cpfCnpj = {
  messages: {
    en: (field, args) => {
      return "CPF/CNPJ inválido.";
    },
    'pt-BR': (field, args) => {
      return "CPF/CNPJ inválido.";
    }
  },
  validate(value) {
    return validateCNPJAlfanumero(value) || validarCPF(value);
  }
};



// WEBPACK FOOTER //
// ./src/validators/cpfCnpj.js